import { render, staticRenderFns } from "./GeneratedWord.vue.js?vue&type=template&id=0f67b216!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./GeneratedWord.vue?vue&type=template&id=0f67b216"
import script from "./GeneratedWord.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./GeneratedWord.vue?vue&type=script&lang=js"
export * from "./GeneratedWord.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./GeneratedWord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports